import Vue from 'vue';
import Router from 'vue-router';

const TheContainer = () => import('@/components/TheContainer');
const Page404 = () => import('@/components/views/Page404');
const Login = () => import('@/components/views/Login');
const Demo = () => import ('@/components/views/Demo');

const Home = () => import('@/components/views/Home');
const Reports = () => import('@/components/views/Reports');
const Cameras = () => import('@/components/views/Cameras');
const Users = () => import('@/components/views/Users');
const Profile = () => import('@/components/views/Profile');
const VehicleList = () => import('@/components/views/VehicleList');
const VehicleTracker = () => import('@/components/views/VehicleTracker');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/',
      redirect: '/home',
      component: TheContainer,
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports,
          props: true
        },
        {
          path: '/cameras',
          name: 'Cameras',
          component: Cameras
        },
        {
          path: '/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: '/vehicle-list',
          name: 'VehicleList',
          component: VehicleList,
          props: true
        },
        {
          path: '/vehicle-tracker',
          name: 'VehicleTracker',
          component: VehicleTracker,
          props: true
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
